<template>
  <div class="heading">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "VgHeading"
}
</script>

<style scoped>
.heading {
  font-weight: normal;
  font-size: 16px;
  margin: 15px;
}
</style>